import React from "react"
import { Link } from "react-router-dom"
import "./SecondaryRegistration.css"
import "../User2/UserProfile.css"

import SignupContainer from "../Signup-Login/SignupContainer"

const AlreadyRegistered = () => {
  return (
    <SignupContainer heading="">
      <div className="already-registered-div">
        <h1>Your account has already been registered</h1>
        <br></br>
        Please click{" "}
        <Link to="/login">
          <button className="already-registered-link">here</button>
        </Link>{" "}
        to sign in.
      </div>
    </SignupContainer>
  )
}

export default AlreadyRegistered
